import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a9d0c2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "leaflet" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-icon" }),
  /*#__PURE__*/_createTextVNode(" 关注绿色环保，共筑蓝天净水 ")
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "大气污染管控智慧云平台", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "see-more" }, [
  /*#__PURE__*/_createTextVNode(" 查看更多 "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "慧眼知火", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "see-more" }, [
  /*#__PURE__*/_createTextVNode(" 查看更多 "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "PIE-engine UAV", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "see-more" }, [
  /*#__PURE__*/_createTextVNode(" 查看更多 "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "PIE-engine 产品", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "see-more" }, [
  /*#__PURE__*/_createTextVNode(" 查看更多 "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

import { useRouter, } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const handlerClick = (path: string) => {
  router.push(`/index/leaflets${path}`);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "item air-pollution",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handlerClick('/airBrochure')))
      }, _hoisted_6),
      _createElementVNode("div", {
        class: "item find-fire",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handlerClick('/fireAnnounce')))
      }, _hoisted_9),
      _createElementVNode("div", {
        class: "item pie-engine-uav",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handlerClick('/uavBrochure')))
      }, _hoisted_12),
      _createElementVNode("div", {
        class: "item pie-engine-productions",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handlerClick('/pieBrochure')))
      }, _hoisted_15)
    ])
  ]))
}
}

})